export const en = {
  heading: "About <highlight>me</highlight>",
  lead: "Hello 👋, I'm a back-end Node.js engineer with 6+ years of experience building APIs, backend services and AI-powered systems.",
  paragraph1:
    "I usually work close to product and engineering teams, turning ideas into maintainable systems with clear planning, pragmatic technical decisions and reliable delivery.",
  paragraph2:
    "I care a lot about communication, ownership and problem solving. I also believe new product features should be documented with enough context to help teams maintain, evolve and use them with confidence.",
  facts: {
    locationLabel: "Location",
    location: "Bahia, Brazil",
    languagesLabel: "Languages",
    languages: "Portuguese, English",
    statusLabel: "Status",
    status: "Open to work",
  },
  cards: [
    {
      icon: "plugsConnected" as const,
      accent: "accent" as const,
      title: "APIs & services",
      description:
        "Production-grade APIs and backend services built with TypeScript and Node.js, using frameworks such as NestJS, with a focus on maintainability, reliability, and continuous delivery.",
    },
    {
      icon: "brain" as const,
      accent: "green" as const,
      title: "AI systems",
      description:
        "Production AI systems using multi-agent workflows, RAG, MCP tooling, evaluation pipelines and internal automation.",
    },
    {
      icon: "database" as const,
      accent: "accent" as const,
      title: "AI-Assisted Engineering",
      description:
        "Software development accelerated by Claude Code, Cursor, OpenCode, T3 Code, and Conductor, supported by MCPs, reusable skills, and structured planning workflows.",
    },
  ],
};
